// Pro display-name → category slug (mirror of /app/backend/pro_categories.py).
// Used by the customer Instant Pricing flow to look up dual-priced real pros
// when a customer opens a pro side-panel (e.g. "Chef" → slug `chef`).

export const PRO_NAME_TO_SLUG = {
  'Chef': 'chef',
  'Biryani Specialist': 'biryani_specialist',
  'Assistant Chef': 'assistant_chef',
  'Server / Waiter': 'server_waiter',
  'Priest / Purohit': 'priest',
  'Photographer': 'photographer',
  'Videographer': 'videographer',
  'Magician': 'magician',
  'Makeup Artist': 'makeup_artist',
  'Mehndi Artist': 'mehndi_artist',
  'Choreographer': 'choreographer',
  'Singer / Vocalist': 'singer',
  'Singer with Karaoke': 'singer_karaoke',
  'Musician': 'musician',
  'Musician / Instrument Player': 'musician',
  'Music Instrument Performer': 'music_instrument_performer',
  'Nadaswaram Artist': 'nadaswaram_artist',
  'Thavil Artist': 'thavil_artist',
  'Dancer / Dance Troupe': 'dancer',
  'Anchor / Emcee': 'anchor_emcee',
  'Catering Team': 'catering_team',
  'Muhurtham Pai / Return Gift': 'return_gift',
  'Decoration Team': 'decoration_team',
  'Standup Comedian': 'standup_comedian',
  'Costume Performer': 'costume_performer',
  'Buffoon': 'buffoon',
  'Buffoon / Clown': 'buffoon',
  'Mimicry Artist': 'mimicry_artist',
  'DJ': 'dj',
};

export const DUAL_PRICING_EXCLUDED_SLUGS = new Set([
  'server_waiter',
  'catering_team',
  'return_gift',
]);

export const slugForProName = (name) => PRO_NAME_TO_SLUG[name];

export const isDualPricingPro = (name) => {
  const slug = slugForProName(name);
  return !!slug && !DUAL_PRICING_EXCLUDED_SLUGS.has(slug);
};
